import React from "react";
import "./style.css"; // Import the CSS file

const Videos = () => {
  return (
    <div className="videos-container bg">
      <h1>Videos</h1>

      <section>
        <h2>Featured Videos</h2>
        <div className="grid-wrapper">{renderVideos(featuredVideos)}</div>
      </section>

      <section>
        <h2>More Videos</h2>
        <div className="grid-wrapper">{renderVideos(moreVideos)}</div>
      </section>
    </div>
  );
};

const renderVideos = (videos) => {
  return videos.map((video, index) => (
    <article key={index}>
      <h3></h3>
      <iframe
        width="100%"
        height="250"
        src={video.url}
        title={video.title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
      <p>{video.description}</p>
    </article>
  ));
};

const featuredVideos = [
  {
    title: "SAVE JAMES",
    url: "https://www.youtube.com/embed/SyiCm4NpGWI",
    description:
      "21 Studios - Interview with American Hero and Father Jeff Younger #SaveJames [Fixed Audio]",
  },
  {
    title: "SAVE JAMES",
    url: "https://www.youtube.com/embed/zGZpPD2Ou_4",
    description:
      "Saving America's Children from Transgender Child Abuse | Jeff Younger | Full Interview",
  },
  {
    title: "SAVE JAMES",
    url: "https://www.youtube.com/embed/XuuBG1lpftc",
    description:
      "RH75 Production - Jeff Younger on child support. This is crazy. Do people know about this? From Timcast irl.",
  },
  {
    title: "",
    url: "https://www.youtube.com/embed/Jjl1Kfrf1zQ",
    description:
      "CBS Texas - Decision Made In Volatile Custody Case Involving Child's Gender Identity",
  },
  {
    title: "",
    url: "https://www.youtube.com/embed/t8HAegNbEsA",
    description:
      "Matt Walsh - Leftist Mob Spits on Presenter for Stating Facts",
  },
  {
    title: "",
    url: "https://www.youtube.com/embed/ELONElv8rdU",
    description:
      "How Fathers are Fundamentally ABUSED in Family Court | Jeff Younger",
  },
];

const moreVideos = [
  {
    title: "SAVE JAMES",
    url: "https://www.youtube.com/embed/qlQUHUKx6mw",
    description:
      "Wait…a teacher did what to your son? Interview with Jeff Younger",
  },
  {
    title: "SAVE JAMES",
    url: "https://www.youtube.com/embed/pqTPuuI5RmI",
    description:
      "Texas is allowing a CRAZY EX to turn his son into a girl! Why you should NEVER marry a feminist...",
  },
  {
    title: "SAVE JAMES",
    url: "https://www.youtube.com/embed/4C_fE7kXqJU",
    description:
      "21 Studios - Cancel-Proof Fatherhood: The Patriarchy in Peril | Jeff Younger | Full 21 Convention Speech",
  },
  {
    title: "SAVE JAMES",
    url: "https://www.youtube.com/embed/UULpRcO9SOc",
    description:
      "Jeff Younger Lost His Son to the Cult of Transgenderism How Can We Stop This From Happening Again",
  },
  {
    title: "SAVE JAMES",
    url: "https://www.youtube.com/embed/C7zJW59rZ1w",
    description:
      "Father FIGHTS to Save His Son From GENDER TRANSITION Nightmare | Pearl Daily",
  },
  {
    title: "SAVE JAMES",
    url: "https://www.youtube.com/embed/HWvSCPMC5Bk",
    description:
      "THE CHARLIE SHOW - Jeff Younger's Heartbreaking Story How He Lost Custody of His Son For Refusing To Call Him A Girl",
  },
];

export default Videos;
